/**
 * Open Flame: centres "fit to content" mega menu dropdowns under their menu item,
 * keeping them inside the header's content area. Sets --mega-offset on each dropdown card.
 */
const DESKTOP = window.matchMedia('(min-width: 990px)');

/** @param {HTMLElement} item */
function align(item) {
  const submenu = item.querySelector(':scope > .menu-list__submenu--fit');
  const panel = submenu?.querySelector(':scope > .menu-list__submenu-inner');
  if (!(submenu instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;

  if (!DESKTOP.matches) {
    panel.style.removeProperty('--mega-offset');
    return;
  }

  const trigger = item.getBoundingClientRect();
  const area = submenu.getBoundingClientRect();
  const styles = getComputedStyle(submenu);
  const start = area.left + (parseFloat(styles.paddingLeft) || 0);
  const end = area.right - (parseFloat(styles.paddingRight) || 0);
  const width = panel.offsetWidth;

  const centred = trigger.left + trigger.width / 2 - width / 2;
  const left = Math.min(Math.max(centred, start), Math.max(start, end - width));
  panel.style.setProperty('--mega-offset', `${Math.round(left - start)}px`);
}

function alignAll() {
  document
    .querySelectorAll('header-menu[data-dropdown-width="fit"] .menu-list__list-item')
    .forEach((item) => align(/** @type {HTMLElement} */ (item)));
}

/** @param {Event} event */
function onEnter(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const item = target.closest('header-menu[data-dropdown-width="fit"] .menu-list__list-item');
  if (item instanceof HTMLElement) align(item);
}

document.addEventListener('pointerover', onEnter, { passive: true });
document.addEventListener('focusin', onEnter);
window.addEventListener('resize', alignAll, { passive: true });
DESKTOP.addEventListener('change', alignAll);
document.addEventListener('shopify:section:load', alignAll);
document.fonts?.ready.then(alignAll);
alignAll();
